module.exports = __webpack_public_path__ + "static/media/hiw9.88a2621e.svg";